import React from 'react';
import { Nav } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { URI_INTERNAL } from '@app/utils/pathLocations';

const ResearchTabs = ({ activeKey }) => {
    const history = useHistory();

    const handleSelect = (key) => {
        switch (key) {
            case 'gioithieu':
                history.push(URI_INTERNAL.PROFILE_CV);
                break;
            case 'baibao':
                history.push(URI_INTERNAL.BAI_BAO_PATH);
                break;
            case 'detai':
                history.push(URI_INTERNAL.DE_TAI_PATH);
                break;
            case 'sangche':
                history.push(URI_INTERNAL.SANG_CHE_PATH);
                break;
            case 'giaithuong':
                history.push(URI_INTERNAL.GIAI_THUONG_PATH);
                break;
            case 'sach':
                history.push(URI_INTERNAL.SACH_PATH);
                break;
            case 'huongdan':
                history.push(URI_INTERNAL.HUONG_DAN_HOC_VIEN_PATH);
                break;
            case 'giaithuongdaotao':
                history.push(URI_INTERNAL.GIAI_THUONG_DAO_TAO_PATH);
                break;
            default:
                break;
        }
    };

    return (
        <div className="bg-white mb-3 shadow-sm rounded">
            <Nav 
                variant="tabs"
                activeKey={activeKey} 
                onSelect={handleSelect} 
                id="research-management-tabs" 
                className="custom-tabs border-bottom px-4 pt-2 bg-light"
            >
                {/* <Nav.Item>
                    <Nav.Link eventKey="gioithieu">1. Giới thiệu khoa học</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                    <Nav.Link eventKey="baibao">2.1 Bài báo công bố</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="detai">2.2 Nhiệm vụ KHCN (Đề tài)</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="sangche">2.3 Sáng chế & GPHU</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="giaithuong">2.4 Giải thưởng NCKH</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="sach">3.1 Sách xuất bản</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="huongdan">3.2 Hướng dẫn học viên</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="giaithuongdaotao">3.3 Giải thưởng Đào tạo</Nav.Link>
                </Nav.Item>
            </Nav>
        </div>
    );
};

export default ResearchTabs;
